import { render } from "./WalletNotAvailable.vue?vue&type=template&id=f38044a6&scoped=true&ts=true"
import script from "./WalletNotAvailable.vue?vue&type=script&lang=ts"
export * from "./WalletNotAvailable.vue?vue&type=script&lang=ts"

import "./WalletNotAvailable.vue?vue&type=style&index=0&id=f38044a6&lang=css&scoped=true"

import exportComponent from "/app/higgs.cps.portal.website/node_modules/.pnpm/vue-loader@16.8.3_f65c6e1beb608835961423903ad857fc/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f38044a6"]])

export default __exports__